import React, { ReactNode, SyntheticEvent } from 'react';

import { LocationDescriptor } from 'history';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BamButton } from './BamButton';

const FloatingBamButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  width: 100%;
  left: 0;
  right: 0;
`;

export const FloatingBamButton: React.FC<{
  to?: string | LocationDescriptor;
  light?: boolean;
  lighter?: boolean;
  disabled?: boolean;
  onClick?:
    | ((event: SyntheticEvent<Element, Event>) => Promise<void>)
    | ((event: SyntheticEvent<Element, Event>) => void);
  type?: 'button' | 'submit';
  children: ReactNode;
}> = ({ to, ...props }) => (
  <FloatingBamButtonContainer>
    {to ? (
      <Link to={to}>
        <BamButton {...props} />
      </Link>
    ) : (
      <BamButton {...props} />
    )}
  </FloatingBamButtonContainer>
);
FloatingBamButton.displayName = 'FloatingBamButton';
